export default __webpack_public_path__ + "static/time150-b8b422bcbd0bfb1796d17e40daa90662.gif";